import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/dashboard";
import Articles from "./pages/articles";
import PeerReviewersPage from "./pages/peer-reviewers";
import EditorialBoardHome from "./pages/editorial-board-home";
import Auth from "./pages/auth";
import AuthContext from "./auth-context";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth" element={<Auth />} />
        
        <Route path="/" element={
          <AuthContext>
            <Dashboard />
          </AuthContext>
        } />

        <Route path="/articles" element={
          <AuthContext>
            <Articles />
          </AuthContext>
        } />

        <Route path="/peer-reviewers" element={
          <AuthContext>
            <PeerReviewersPage />
          </AuthContext>
        } />

        <Route path="/editorial-board" element={
          <AuthContext>
            <EditorialBoardHome />
          </AuthContext>
        } />

       
      </Routes>
    </BrowserRouter>
  );
}

export default App;
